var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.DataMngrDataRequest = new Class({
    Extends: OCS.Viewer.Classes.AbstractSubscriptionDataRequest,
    class_name: "DataMngrDataRequest",
    options: {
        date_request: false,
        data_category_keys: {'variables': "JSON"},
        metadata: {
            req_cat_type: 'DataMngrDataRequest'
        }
    },
    get_data_manager: function() {
        return OCS.Viewer.Functions.get_data_manager();
    },
    on_make_request_active: function () {
        OCS.Viewer.Functions.get_data_manager().fireEvent('process_data_request', this, 1);
        this.parent();
    },
    is_data_valid: function (data) {
        var metadata = data.get_info();
        var gridded = data.is_gridded();
        var dataset = data.get_dataset();
        var json = data.json();
        if (data && dataset === this.options.metadata.dataset && ((data.contains_all_data_variables(this.get_variables()) && gridded === this.options.metadata.grid) || (this.options.date_request && json.dates))) {
            if (this.options.metadata.url !== undefined && this.options.metadata.url !== null && this.options.metadata.url !== "") {
                if (this.options.metadata.url === metadata.url) {
                    return true;
                } else {
                    return false;
                }
            }
            return true;
        }
        return false;

    },
    is_valid: function () {
        var ops = this.get_metadata();
        if (ops.dataset && (ops.variables.length || this.is_date_request() || this.has_url()) && this.failure_count < this.options.max_failure_attempts) {
            return true;
        } else {
            return false;
        }
    },
    is_date_request: function () {
        return this.options.date_request;
    },
    contains_data_variable: function (test_variables) {
        var vars = this.get_variables();
        var contains = false;
        if (!vars.length && !test_variables.length) {
            return true;
        } else {
            vars.each(function (variable) {
                if (OCS.Utilities.array_has_object_with_prop(test_variables, variable)) {
                    contains = true;
                }
            });
        }
        return contains;
    }
});
